import type { StateType } from '../lib/types/state-type';
import { createInitialState } from '../lib/types/state-type';
import type { ManageStateType } from '../lib/types/manage-state-type';
import { FurnhomeCommunicationToken } from '@dh-software/furnhome-communication';
import type { FurnhomeCommunication } from '@dh-software/furnhome-communication';
import { Observer } from '../observer/observer';
import { setEnvironment } from './reducer/set-environment-reducer';
import { setContent } from './reducer/set-content-reducer';
import { changeLanguage } from './reducer/change-language-reducer';
import { checkSession } from './reducer/check-session-reducer';
import { login } from './reducer/login-reducer';
import { logout } from './reducer/logout-reducer';
import { switchStore } from './reducer/switch-store-reducer';
import { applyRoute } from './reducer/apply-route-reducer';
import { setModuleRoute } from './reducer/set-module-route-reducer';
import { inject, singleton } from 'tsyringe';

@singleton()
export class StateManager {
  constructor(
    @inject(Observer) private observer: Observer,
    @inject(FurnhomeCommunicationToken) private communication: FurnhomeCommunication,
  ) {}

  private state: StateType = createInitialState();

  public async manageState(request: ManageStateType, parameters: unknown[], publish = true): Promise<void> {
    switch (request) {
      case 'SET-ENVIRONMENT':
        this.state = setEnvironment(this.state, parameters);
        break;
      case 'CHECK-SESSION':
        this.state = await checkSession(this.state, this.communication);
        break;
      case 'LOGIN':
        this.state = login(this.state, this.communication);
        break;
      case 'LOGOUT':
        this.state = logout(this.state, this.communication);
        break;
      case 'CHANGE-LANGUAGE':
        this.state = changeLanguage(this.state, parameters);
        break;
      case 'SET-CONTENT':
        this.state = setContent(this.state, parameters);
        break;
      case 'SWITCH-STORE':
        this.state = switchStore(this.state, parameters, this.communication);
        break;
      case 'APPLY-ROUTE':
        this.state = applyRoute(this.state, parameters);
        break;
      case 'SET-MODULE-ROUTE':
        this.state = setModuleRoute(this.state, parameters);
        break;
    }

    if (publish) {
      this.observer.publish('publish', this.state);
    }
  }
}
